import { CHART_MARGIN, SOURCE_FILL, Y_AXIS_WIDTH } from './chartStyle'
import { formatBucketTime } from './format'
import type { LeakV0SourceRun } from './chartModel'

interface LeakV0SourceRailProps {
  runs: LeakV0SourceRun[]
  fromMs: number
  toMs: number
}

const clampPercent = (value: number): number => Math.min(Math.max(value, 0), 100)

export const LeakV0SourceRail = ({ runs, fromMs, toMs }: LeakV0SourceRailProps) => {
  const spanMs = Math.max(toMs - fromMs, 1)
  const percentAt = (atMs: number) => clampPercent(((atMs - fromMs) / spanMs) * 100)

  return (
    <div style={{ paddingLeft: Y_AXIS_WIDTH + CHART_MARGIN.left, paddingRight: CHART_MARGIN.right }}>
      <div className="relative h-2 w-full overflow-hidden rounded-sm bg-[var(--gray-3)]">
        {runs.map((run) => {
          const left = percentAt(run.fromMs)

          return (
            <div
              key={run.key}
              className="absolute inset-y-0"
              title={`${run.source} · ${formatBucketTime(run.fromMs)} → ${formatBucketTime(run.toMs)}`}
              style={{
                left: `${left}%`,
                width: `${percentAt(run.toMs) - left}%`,
                backgroundColor: SOURCE_FILL[run.source]
              }}
            />
          )
        })}
      </div>
    </div>
  )
}
